import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";
import "./Home.css";

const images = [
  "/home-hero1.webp",
  "/home-hero2.webp",
  "/home-hero3.webp",
];

const HomeHero = () => {
  const [animateKey, setAnimateKey] = useState(0);

  return (
    <section className="hero">

      <Swiper
        modules={[Autoplay]}
        autoplay={{
          delay: 3500,
          disableOnInteraction: false,
        }}
        loop={true}
        speed={1500}
        slidesPerView={1}
        onSlideChange={() => setAnimateKey(prev => prev + 1)}
        className="hero-swiper"
      >
        {images.map((img, i) => (
          <SwiperSlide key={i}>
            <div
              className="hero-bg"
              style={{
                backgroundImage: `
                 linear-gradient(
  270deg,
  rgba(230, 229, 229, 0.3),
  rgba(0, 0, 0, 0.6)
),
                  url(${img})
                `,
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>

     
      <div className="hero-content">

        <h1 key={animateKey} className="main-heading split-text">
          {"WHERE YOUR DREAM PROPERTY BECOMES REALITY"
            .split(" ")
            .map((word, index) => (
              <span
                key={index}
                className="split-word"
                style={{ animationDelay: `${index * 0.15}s` }}
              >
                {word}&nbsp;
              </span>
            ))}
        </h1>

      </div>

    </section>
  );
};

export default HomeHero;
